import '@/utils/pollyfills';
import { initApp } from './app';
import { config } from './config/config';

window.chunksUrl = config.assets;

initApp();
